import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import styles from './ContactModule.style';
import StackGrid from '../StackGrid';
import ModuleContent from '../../components/ModuleContent';

const ContactModule = ({ title, body, mail, className: classNameProp, ...other }) => {
  const className = clsx(styles.root, classNameProp);

  return (
    <>
      <ModuleContent className={className} {...other}>
        <Text variant="medium" className={styles.titleText}>
          {title}
        </Text>
        <Text variant="medium" className={styles.infoText}>
          {body}
          <br />
          Support is available from 6am-3pm PST.
        </Text>

        <StackGrid smCols={1} mdCols={1} lgCols={2} className={styles.contactInfo}>
          <div>
            <a href={`mailto:${mail}`} className={styles.link}>
              <Text variant="medium" className={styles.infoText}>
                <FontIcon iconName="Mail" ariaLabel="Mail" id="mail-icon" className={styles.icon} />
                {mail}
              </Text>
            </a>
          </div>
        </StackGrid>
      </ModuleContent>
    </>
  );
};

ContactModule.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  mail: PropTypes.string.isRequired,
  className: PropTypes.string,
};

ContactModule.defaultProps = {
  title: '',
  className: '',
};

export default ContactModule;
